import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../../api";
import { OrgCategory } from "../../../generated/core-api";

/**
 * Hook for rescinding organization invitations
 */
export function useRescindOrgInvitation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      category,
      orgId,
      invitationId,
    }: {
      category: OrgCategory;
      orgId: string;
      invitationId: string;
    }) => {
      return await api.rescindInvitation(category, orgId, invitationId);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["orgs", variables.category, variables.orgId, "invitations"],
      });
    },
  });
}
